import React from 'react'

export const CarouselArrow = props => {
	const { className, onClick, children } = props

	return <div className={className} onClick={onClick}>{children}</div>
}

export default CarouselArrow


// WEBPACK FOOTER //
// ./src/components/CarouselArrow.js